import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { ConfigurationModel, GroupModel } from 'franke-trough-dependencies';
import classNames from 'classnames';

import { GlobalPrivateState, QueryParameterState } from 'src/api';
import { FolderListItem } from './ListItem/FolderListItem';
import { RouterState } from 'connected-react-router';

import './FolderList.scss';
import { Icon } from '../../Images';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './FolderList.messages';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
// import { filterConfigurationsBySword } from '../../User/utils';

export interface FolderListProps {
  authenticator: GlobalPrivateState['authenticator'];
  user: GlobalPrivateState['user'];
  groups: GlobalPrivateState['groups'];
  userData: GlobalPrivateState['userData'];
  location: RouterState['location'];
  params: QueryParameterState['params'];
  queryState: GlobalPrivateState['queryState'];
  limit?: number;
  folderId?: string;
  dispatch: Function;
}

export interface FolderListState {
  idOfActiveSettings?: string;
  tabListStates: any;
}

const initialTabListStates = {
  mine: {
    skip: 0,
    rowCount: 0,
    loadingMore: false,
    reachedEnd: false
  },
  others: {
    skip: 0,
    rowCount: 0,
    loadingMore: false,
    reachedEnd: false
  },
  archived: {
    skip: 0,
    rowCount: 0,
    loadingMore: false,
    reachedEnd: false
  }
}

export class FolderListPartial extends React.Component<FolderListProps, FolderListState> {

  constructor(props: FolderListProps) {
    super(props);

    this.state = {
      tabListStates: JSON.parse(JSON.stringify(initialTabListStates))
    }
  }

  componentDidMount() {
    // this.handleLoadMore();
  }

  componentDidUpdate(prevState: FolderListProps) {
    const prevGroups = prevState.groups && prevState.groups.result;
    const prevParams = JSON.parse(JSON.stringify(prevState.queryState.params));
    const groups = this.props.groups && this.props.groups.result;
    const params = JSON.parse(JSON.stringify(this.props.queryState.params));

    const foldersChanged = JSON.stringify(prevGroups) !== JSON.stringify(groups);

    if (foldersChanged && groups) { // Just triggers re-render I think?
    // console.log('groups updated', groups);
      const newState = this.state;
      this.setState(newState);
    }
  }

  public render() {
    const { groups, authenticator, user, userData, limit, folderId } = this.props;
    const { list, tab } = this.props.params;
    const isGroupsReady = this.groupsForCurrentTab && Array.isArray(this.groupsForCurrentTab) && this.groupsForCurrentTab.length > 0;

    return (
      <div className="partial-folder-list w-100 d-flex flex-wrap">
        {folderId ? (
          <h5 className="heading"><FormattedMessage {...MESSAGES.folderListNestedHeading} /></h5>
        ) : (
          <h5 className="heading"><FormattedMessage {...MESSAGES.folderListHeading} /></h5>
        )}

        <div className={classNames('folder-view', 'w-100')}>
          <div className="row">
            {isGroupsReady && this.groupsForCurrentTab && this.groupsForCurrentTab.map((group, index) => {
              const key = `group_list_item_${index}`;
              

              if (limit && index > limit || group.type !== 'folder') { return }

              if (limit && index === limit) {
                return (
                  <div key={key} className={classNames('col-12 col-md-6 col-lg-4 mb-3')}>
                    <div className="d-flex h-100">
                      <div className={`partial-folder-list-item w-100`}>
                        <Link to={`/folders`} className="folder folder-more w-100 h-100 d-flex">
                          <Icon name="double-chevron" /><FormattedMessage {...MESSAGES.folderListSeeAll} />
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              }

              return (
                <div key={key} className={classNames('col-12 col-md-6 col-lg-4 mb-3')}>
                  <div className="d-flex h-100">
                    <FolderListItem 
                      user={user}
                      userData={userData}
                      group={group}
                      isNested={folderId ? true: false}
                    />
                  </div>
                </div>
              );
            }) || (
              <div className="folder-none col-12">
                <FormattedMessage {...MESSAGES.folderListNone} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  private get groupsForCurrentTab(): GroupModel[] | undefined {
    const { groups, authenticator, userData, params, folderId } = this.props;
    if (!groups || !groups.result || !authenticator.accessToken || !userData.result) {
      return [];
    }

    const tab = params.tab || 'mine';
    const userId = authenticator.accessToken.userId.toString();
    const archivedConfigurations = userData.result.archivedConfigurations || [];
    const deletedConfigurations = userData.result.deletedConfigurations || [];
    let groupsForTab = groups.result;
    
    if (folderId) {
      groupsForTab = groupsForTab.filter(g => g.parentId === folderId);
    } else {
      groupsForTab = groupsForTab.filter(g => !g.parentId);
    }

    // We keep filtering in front-end... since we save all configurations on tab change
    // if (tab === 'mine') {
    //   configurationsForTab = groups.result.filter(c => c.userId === userId && !archivedConfigurations.includes(c.id));
    // } else if (tab === 'others') {
    //   configurationsForTab = groups.result.filter(c => c.userId !== userId && !archivedConfigurations.includes(c.id));
    // } else if (tab === 'archived') {
    //   configurationsForTab = groups.result.filter(c => archivedConfigurations.includes(c.id));
    // }

    // Deleted tabs
    if (groupsForTab) {
      // groupsForTab = groupsForTab.filter(c => !deletedConfigurations.includes(c.id) && !c.deleted);

      // // Duplicates...
      // const existingIds: string[] = [];
      // groupsForTab = groupsForTab.filter(c => {
      //   if (!existingIds.includes(c.id)) {
      //     existingIds.push(c.id);
      //     return c;
      //   }

      //   return null;
      // });
    }

    return groupsForTab;
  }
}

export const FolderList = connect((state: GlobalPrivateState) => ({
  groups: state.groups,
  authenticator: state.authenticator,
  user: state.user,
  userData: state.userData,
  location: state.router.location,
  params: state.queryState.params,
  queryState: state.queryState
}))(FolderListPartial);

export default FolderList;